<mat-toolbar class="d-flex form-editor-toolbar">

    <div *ngIf="loaded()" class="form-info">
        <div class="overline">Form v.{{procedureForm.version}} / {{procedureForm.name}}</div>
        <div (click)="showSectionSelector.emit(selectorElementRef)" class="mat-title d-flex align-items-center" style="gap: 8px;">
            <div *ngIf="showCurrentSection()" class="section-name" #selector>{{sectionHistoryService.currentHistoryChange!.sectionForm()!.name}}</div>
            <button mat-icon-button>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="loadingHttp()" class="d-flex align-items-center">
        <mat-spinner color="warn" diameter="20"></mat-spinner>
        <div class="overline">Guardant...</div>
    </div>

    <div style="flex: 1 0 0;"></div>

    <div [hidden]="!loaded()">

        <button (click)="showPreview.emit()" mat-icon-button>
            <mat-icon class="material-icons-outlined">visibility</mat-icon>
        </button>
        <button mat-icon-button [disabled]="!sectionHistoryService.undoAvailable()" (click)="unDo()">
            <mat-icon>undo</mat-icon>
        </button>
        <button mat-icon-button [disabled]="!sectionHistoryService.redoAvailable()" (click)="reDo()">
            <mat-icon>redo</mat-icon>
        </button>
        
    </div>

</mat-toolbar>
